import React from 'react';
import { useTranslation } from 'react-i18next';

export function DeliveryStatus({ code }) {
  const statusColor = code.includes('success') ? 'bg-emerald-500' : 'bg-red-500';
  const statusText = code.includes('success') ? 'Успешная доставка' : 'Неудачная попытка доставки';
  return (
    <span className={`inline-block rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide text-white ${statusColor}`}>
      {statusText}
    </span>
  );
}

export function DeliveryListItem({ code, stamp, code_description, receiver_name, receiver_position }) {
  const { t } = useTranslation();
  const date = new Date(stamp);
  const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

  return (
    <div className="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 sm:py-5">
      <dt className="text-sm font-medium uppercase tracking-wide text-ink-400">{t('delivery-details-date-time')}</dt>
      <dd className="mt-1 text-sm text-ink-100 sm:col-span-2 sm:mt-0">{formattedDate}</dd>

      <dt className="text-sm font-medium uppercase tracking-wide text-ink-400">{t('delivery-details-description')}</dt>
      <dd className="mt-1 text-sm text-ink-100 sm:col-span-2 sm:mt-0">{code_description}</dd>

      {code.includes('success') && (
        <>
          <dt className="text-sm font-medium uppercase tracking-wide text-ink-400">{t('delivery-details-receiver-name')}</dt>
          <dd className="mt-1 text-sm text-ink-100 sm:col-span-2 sm:mt-0">{receiver_name || '-'}</dd>

          <dt className="text-sm font-medium uppercase tracking-wide text-ink-400">{t('delivery-details-receiver-position')}</dt>
          <dd className="mt-1 text-sm text-ink-100 sm:col-span-2 sm:mt-0">{receiver_position || '-'}</dd>
        </>
      )}
    </div>
  );
}

function isSuccessfulDelivery(delivery) {
  return delivery.code.includes('success');
}

function sortDeliveries(deliveries) {
  return [...deliveries].sort((a, b) => {
    if (isSuccessfulDelivery(a) !== isSuccessfulDelivery(b)) {
      return isSuccessfulDelivery(a) ? -1 : 1;
    }

    return new Date(b.stamp) - new Date(a.stamp);
  });
}

export default function DeliveryDetails({ deliveries }) {
  const sortedDeliveries = deliveries ? sortDeliveries(deliveries) : [];

  return (
    <div className="container mx-auto mt-5">
      {sortedDeliveries.map((delivery, index) => (
        <div
          key={index}
          className={`mb-4 overflow-hidden rounded-2xl border border-white/10 bg-night-700/70 shadow-panel ${
            delivery.code.includes('success') ? 'border-t-4 border-t-emerald-500' : 'border-t-4 border-t-red-500'
          }`}
        >
          <div className="px-4 py-5 sm:px-6">
            <p className="max-w-2xl">
              <DeliveryStatus code={delivery.code} />
            </p>
          </div>
          <div className="border-t border-white/10 px-4 py-5 sm:p-0">
            <dl className="sm:divide-y sm:divide-white/10">
              <DeliveryListItem {...delivery} />
            </dl>
          </div>
        </div>
      ))}
    </div>
  );
}
